import JourneyPoint from '@/models/JourneyPoint'
import { AddressTransformer } from '@/transformers/AddressTransformer'
import { PointTransformer } from '@/transformers/PointTransformer'

export class JourneyPointTransformer {
    constructor (addressTransformer = new AddressTransformer(), pointTransformer = new PointTransformer()) {
        this.addressTransformer = addressTransformer
        this.pointTransformer = pointTransformer
    }
    transform (data) {
        return new JourneyPoint(
            this.addressTransformer.transform(data.address),
            null != data.location ? this.pointTransformer.transform(data.location) : null,
            data.utc
        )
    }
}
